<template>
  <section class="tablePage" ref="tableBox">
    <el-table
      v-loading="tableData.loading"
      ref="multipleTable"
      :data="tableData.data"
      tooltip-effect="dark"
      height="300"
      :row-class-name="setRowClassName"
      @select="handleSelectionChange"
      @select-all="handleSelectionChange"
    >
      <!-- 选择框 -->
      <el-table-column v-if="!isRadio" type="selection" width="55" />
      <!-- 选择框 end -->
      <el-table-column v-if="isRadio" width="55" label="选择">
        <template slot-scope="scope">
          <el-radio :label="scope.row[tableData.selectTar]">&nbsp;</el-radio>
        </template>
      </el-table-column>
      <!-- 操作按钮 -->
      <el-table-column
        fixed="right"
        label="操作"
        v-if="showCtrlUpDownBtn"
        align="center"
      >
        <template slot-scope="scope">
          <section class="ctrl-updown-box">
            <i
              class="iconfont primary cur"
              @click="goUp(scope.$index)"
              v-if="scope.$index"
              >&#xe603;</i
            >
            <i
              class="iconfont primary cur"
              @click="goDown(scope.$index)"
              v-if="scope.$index !== tableData.data.length - 1"
              >&#xe604;</i
            >
          </section>
        </template>
      </el-table-column>
      <!-- 操作按钮 end -->
      <!-- 常规列表项 -->
      <el-table-column
        v-for="(item, index, key) in tableData.title"
        :key="key"
        :prop="item.prop"
        :label="item.label"
        :type="item.type || null"
        :sortable="item.sortable"
        :filters="item.filters"
        :filter-method="item.filterHandler"
        :min-width="item.minW"
        :width="item.w"
        :fixed="item.fixed"
      >
      </el-table-column>
    </el-table>
  </section>
</template>

<script>
import tableMixin from '@qx/mixin/table';
export default {
  mixins: [
    tableMixin,
  ],
  props: {
    isRadio: {
      type: Boolean,
      default: false,
    },
    // 表头
    tableDataTitle: {
      type: Array,
      default: () => ([]),
    },
    // 判断是否选中的字段名
    tableDataSelectTar: {
      type: String,
      default: 'id',
    },
    // 是否显示操作按钮
    showCtrlUpDownBtn: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectTar: this.tableDataSelectTar,
        selectResult: [], // 表格选中的结果
        title: this.tableDataTitle,
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    // 设置数据
    setTableData (data) {
      this.tableData.data = data;
    },
    // 移除中指定的数据
    removeTableData (inserDataList) {
      const newDataList = this.tableData.data.filter((originItem) => !inserDataList.some((insertItem) => insertItem[this.tableDataSelectTar] === originItem[this.tableDataSelectTar]));
      this.tableData.data = newDataList;
    },
    // 在底部插入指定的数据
    insertTableData (inserDataList) {
      this.tableData.data.push(...inserDataList);
    },
    // 获取选中的数据
    getSelectedResult () {
      return this.tableData.selectResult;
    },
    // 重置选中的数据
    resetSelectedResult () {
      this.tableData.selectResult = [];
    },
    // 往上
    goUp (index) {
      this.swapArr(this.tableData.data, index, index - 1);
    },
    // 往下
    goDown (index) {
      this.swapArr(this.tableData.data, index, index + 1);
    },
    // 数组元素位置更换
    swapArr (arr, currentIndex, targetIndex) {
      arr.map((item) => item.active = false);
      arr[currentIndex].active = true;
      arr[currentIndex] = arr.splice(targetIndex, 1, arr[currentIndex])[0];
      return arr;
    },
    // 当前操作项目设置高亮
    setRowClassName ({ row, index }) {
      let rowClassName = '';
      if (row.active) {
        rowClassName = 'active';
      }
      return rowClassName;
    },
  },
};
</script>

<style scoped lang="scss">
.ctrl-updown-box {
  display: flex;
  justify-content: space-around;
  .ctrl-updown-icon {
    font-size: 16px;
  }
}

::v-deep .el-table .active {
  background-color: #e6f3ff !important;
}
</style>
